import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
	name: "decimalTen",
})
export class DecimalTenPipe implements PipeTransform {
	transform(value: string | number | undefined | null): number {
		if (typeof value === "string") {
			return parseFloat(value);
		}
		return value as number;
	}
}
